import { useRef } from 'react'
import { Icon, type TIconProps } from '~/components/icon'
import { useChipsContext } from '../../chips'
import {
  ChipsBadage,
  ChipsButtonVariants,
  ChipsContainer,
  ChipsIcoMultiple,
} from '../../chips.styles'
import type { ChipsMultipleProps, ChipsScopedProps } from '../../chips.types'
import { UseChips } from '../../hooks/use-chips'

export const ChipsMultiple = (props: ChipsScopedProps<ChipsMultipleProps>) => {
  const {
    __scopeChips,
    children,
    icon,
    onChange = () => {},
    count = 0,
  } = props;
  const {
    size = 'md',
    disabled,
    checked,
    readOnly,
  } = useChipsContext('Chips', __scopeChips);
  const { iconSizeMapping } = UseChips();
  const chipsRef = useRef<HTMLButtonElement>(null);
  const hasChecked = checked || count > 0;
  const iconSymbol = icon ? icon : 'rdicon-options-filter';

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled || readOnly) {
      event.preventDefault();
      return;
    }
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <div className={ChipsContainer()}>
      <button
        type="button"
        className={ChipsButtonVariants({
          size,
          disabled,
          hasChecked,
          readOnly,
        })}
        ref={chipsRef}
        onClick={handleButtonClick}
        disabled={disabled || readOnly}
      >
        <span className={ChipsIcoMultiple({ size })}>
          <Icon
            size={iconSizeMapping[size]}
            symbol={iconSymbol as TIconProps['symbol']}
            color={
              disabled ? 'colorTextNeutralDisabled' : 'colorTextNeutralDefault'
            }
          />
        </span>
        {children}
        {count > 0 && (
          <span className={ChipsBadage({ size, disabled })}>
            {count > 9 ? '9+' : count}
          </span>
        )}
      </button>
    </div>
  )
}
